<script setup>
import { computed, inject } from "vue";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="bg-white p-12 rounded-lg shadow-lg">
        <!-- Title -->
        <h2
          class="text-3xl md:text-4xl"
        >{{ $t('Dienstverlening binnen de Gehandicaptenzorg en GGZ') }}</h2>

        <!-- Description -->
        <p
          class="mt-4 text-lg"
        >{{ $t('Werken in de GGZ en gehandicaptenzorg brengt uitdagingen met zich mee. De tekorten zijn groot, de werkdruk hoog, en het vinden van de juiste mensen is niet eenvoudig – vooral wanneer vaste gezichten de voorkeur hebben. Wij begrijpen deze worstelingen en bieden oplossingen die écht verschil maken.') }}</p>

        <!-- Service Cards -->
        <div class="mt-8 grid md:grid-cols-3 gap-6">
          <!-- Card 1 -->
          <div class="bg-[#E7F3EB] p-6 rounded-lg shadow-md">
            <h3 class="text-xl font-semibold">{{ $t('Begeleiding op maat') }}</h3>
            <p
              class="mt-2 text-lg"
            >{{ $t('Zorgblik biedt persoonlijke ondersteuning die aansluit bij de behoeften van zorginstellingen en professionals. Of het nu gaat om coaching, ondersteuning op de werkvloer of strategisch advies, onze aanpak is altijd afgestemd op jouw situatie. Samen werken we aan duurzame verbeteringen en hoogwaardige zorg.') }}</p>
          </div>

          <!-- Card 2 -->
          <div class="bg-[#E7F3EB] p-6 rounded-lg shadow-md">
            <h3 class="text-xl font-semibold">{{ $t('Platform') }}</h3>
            <p
              class="mt-2 text-lg"
            >{{ $t('Periodieke opdrachten als oplossing. Met onze gecertificeerde GGZ-professionals lossen we tijdelijke tekorten op. Zij ondersteunen je zorgteam enkele weken of maanden, zodat cliënten steeds dezelfde vertrouwde gezichten zien – essentieel voor goede zorg.') }}</p>
          </div>

          <!-- Card 3 -->
          <div class="bg-[#E7F3EB] p-6 rounded-lg shadow-md">
            <h3 class="text-xl font-semibold">{{ $t('Kwaliteit van zorg is belangrijk') }}</h3>
            <p
              class="mt-2 text-lg"
            >{{ $t('Kwaliteit van zorg is essentieel, vooral in de GGZ en gehandicaptenzorg. Wij werken samen met empathische professionals die écht begrijpen hoe ze mensen met psychische problemen kunnen ondersteunen.') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  